export const entity = {
    name: 'LargeImputation',
    fields:[
        {path: 'organization', type: 'Organization'},
        //'Currency',
        {path: 'amount', type: 'decimal'},
    ],
}
